import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import UserContext from '../../../../common/utils/getContext';
import T from '../../../../common/components/T';

export default function ConfirmPresence() {
    const { setAlertData } = useContext(UserContext);
    const router = useRouter();

    useEffect(() => {
        if (router?.query?.['confirm-presence'] === 'success') {
            setAlertData({
                type: 'success',
                cont: <T textName='confirm-presence-success-message' defaultStr='Билет успешно подтвержден' page='/office' />
            });
        } else if (router?.query?.['confirm-presence'] === 'noAccess') {
            setAlertData({
                type: 'error',
                cont: (
                    <T
                        textName='confirm-presence-noAcess-message'
                        defaultStr='У Вас нету доступа для подтверждения билета'
                        page='/office'
                    />
                )
            });
        }
    }, []);

    return null;
}
